import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ text = "Lütfen bekleyin..." }) => (
  <div className="loading-spinner-container">
    <div className="loading-spinner" />
    <p>{text}</p>
  </div>
);

export default LoadingSpinner;